import React from "react";
import Carousel from "../careers/carousel/Carousel";

interface ITestimonial {
  id: number;
  name: string;
  description: string;
  position: string;
  secondPosition?: string;
  image: string;
  linkedin: string;
}

interface TestimonialProps {
  title: string;
  smallDecription: string;
}

const TourismTestimonials: React.FC<TestimonialProps> = ({
  title,
  smallDecription,
}) => {
  const testimonials: ITestimonial[] = [
    {
      id: 1,
      name: "Riya Sharma",
      image: "/tourism/testimonial/riya.png",
      description:
        "Tourism App Solutions makes solo travel stress-free! From finding hidden gems to booking stays, it’s my go-to travel buddy. The intuitive interface makes planning seamless and fun!.",
      position: "Solo Traveler (Mumbai, India)",
      linkedin: "linkedin.com/in/sarahchen",
    },
    {
      id: 2,
      name: "Sophia Martinez",
      image: "/tourism/testimonial/sophia.png", // learning/testimonials/testimonial-2.png
      description:
        "Planning family vacations has never been easier. The app ensures smooth bookings, local recommendations, and a hassle-free trip! My kids love the fun activity suggestions tailored for families.",
      position: "Family Traveler (Toronto, Canada)",
      linkedin: "linkedin.com/in/mrodriguez",
    },
    {
      id: 3,
      name: "Emily Johnson",
      image: "/tourism/testimonial/emily.png",
      description:
        "From five-star hotels to exclusive experiences, this app curates the best luxury travel options with ease. It even recommends premium concierge services to enhance the journey.",
      position: "Luxury Traveler (New York, USA)",
      linkedin: "linkedin.com/in/priyapatel",
    },
    {
      id: 4,
      name: "David Collins",
      image: "/tourism/testimonial/david.png",
      description:
        "This app takes adventure planning to the next level. Whether it's trekking or scuba diving, I find everything I need in one place! It’s like having a personal adventure guide in my pocket.",
      position: "Adventure Enthusiast (Sydney, Australia)",
      linkedin: "linkedin.com/in/priyapatel",
    },
    {
      id: 5,
      name: "Ahmed Khan",
      image: "/tourism/testimonial/ahmed.png",
      description:
        "For work trips, this app is a lifesaver. It helps me book accommodations, find local hotspots, and manage my itinerary effortlessly. It even suggests networking-friendly cafés and workspaces!",
      position: "Business Traveler (Dubai, UAE)",
      linkedin: "linkedin.com/in/priyapatel",
    },
    {
      id: 6,
      name: "Carlos Rivera",
      image: "/tourism/testimonial/carlos.png",
      description:
        "Backpacking is all about freedom, and this app helps me discover affordable stays, best routes, and must-visit spots! It’s perfect for budget travelers who want adventure without the hassle.",
      position: "Backpacker (Barcelona, Spain)",
      linkedin: "linkedin.com/in/priyapatel",
    },
  ];
  return (
    <div>
      <div className="w-full flex justify-center items-center">
        <div className="text-center max-w-6xl xl:pt-5">
          <h3 className="text-xl text-center font-light xl:text-6xl sm:text-2xl md:text-3xl lg:text-4xl">
            {title}
          </h3>
          <p className="text-neutral-600 pt-2 xl:pt-4 xl:text-[1.6rem] font-light">
            {smallDecription}
          </p>
        </div>
      </div>
      <div className="py-5 p-2 xl:px-20">
        <Carousel slides={testimonials} />
      </div>
    </div>
  );
};

export default TourismTestimonials;
